import { AppConfig, DEFAULT_FEATURES } from 'ut-business/shared';

export const aeroviewConfig: AppConfig = {
  appName: 'AeroView',
  appIcon: 'plane',
  appInitials: 'AV',
  features: {
    ...DEFAULT_FEATURES,
    indication: {
      columns: [
        'configName',
        'snr',
        'thresholdMode',
        'threshold',
        'areaZ',
        'lengthMaxZ',
        'widthMaxZ',
        'mean',
        'stdDev',
        'flawType',
        'verdict',
        'details',
        'imageButton',
      ],
      detailReadings: [
        'positionLength',
        'positionWidth',
        'pMaxZ2D',
        'positionScan',
        'positionIndex',
        'zScanStart',
        'zScanEnd',
        'zIndexStart',
        'zIndexEnd',
        'nzScanStart',
        'nzScanEnd',
        'nzIndexStart',
        'nzIndexEnd',
      ],
      flawTypes: [
        'Porosity',
        'Delam void',
        'Foreign material',
      ],
    },
    analysis: true,
    aScanBitDepth: false,
    canAlignData: false,
    canStitchData: false,
    cScanThickness: true,
    deviceManager: true,
    dgs: false,
    dynamicGateMeasurementCursor: false,
    firingSequence: true,
    gateAndTcgSyncho: true,
    inspection: true,
    materialLossReading: false,
    mergeFiles: true,
    scannerMenu: true,
    snapToMinThickness: false,
    showStickynotes: true,
    snr: true,
    tcgReferenceAmplitudeLine: false,
    tilingCanvas: true,
    zoneStatistics: true,
  },
};
